module.exports = __webpack_public_path__ + "img/draw_temuout1.378ec95e.png";